/**
 * 開発環境またはステージング環境かどうかを判定
 */
export const isDevelopmentOrStaging = (): boolean => {
  return (
    import.meta.env.DEV ||
    import.meta.env.VITE_APPLICATION_ENV === 'stage1' ||
    import.meta.env.VITE_APPLICATION_ENV === 'stage2' ||
    import.meta.env.VITE_APPLICATION_ENV === 'stage3'
  )
}

/**
 * dct環境かどうかを判定
 */
export const isDct = (): boolean => {
  return import.meta.env.VITE_APPLICATION_ENV === 'dct'
}

/**
 * SSOログインが設定されているかどうかを判定
 *
 * ドメインとIDP名の両方を見る。AmplifyのOAuth設定は`VITE_COGNITO_DOMAIN`でゲートされて
 * いるため（`src/lib/aws-amplify/index.ts`）、IDP名だけが設定された状態でボタンを出すと
 * `signInWithRedirect`が`assertOAuthConfig`で失敗する。
 */
export const isSSOEnabled = (): boolean => {
  return Boolean(
    import.meta.env.VITE_COGNITO_DOMAIN &&
    import.meta.env.VITE_COGNITO_IDP_NAME,
  )
}
